import { ApiError, CreateLawEnforcePointDto, LawEnforcePoint } from '@36node-fcp/core-sdk';
import { Alert, Form, Input, message, Modal } from 'antd';
import styled from 'styled-components';

import { LawEnforcePointApiErrorMap } from 'src/features/law-enforce-point';
import { useApi } from 'src/lib/react-api';
import { fcp, passFcpApiErrors } from 'src/services';

type EditorValues = CreateLawEnforcePointDto & {};

interface LawEnforcePointEditorProps {
  lawEnforcePoint?: LawEnforcePoint;
  onClose: () => void;
  onFinish?: () => void;
}

export const LawEnforcePointEditor: React.FC<LawEnforcePointEditorProps> = ({
  lawEnforcePoint,
  onClose: handleClose,
  onFinish: handleFinish,
}) => {
  const isEdit = !!lawEnforcePoint;
  const onSuccess = () => {
    message.success(isEdit ? '编辑成功' : '创建成功');
    handleClose();
    handleFinish?.();
  };

  const onFailure = (err: ApiError) => {
    const ne = passFcpApiErrors(err, LawEnforcePointApiErrorMap);
    if (ne.keys) {
      ne.keys.forEach((key) => form.setFields([{ name: key, errors: [ne.message[key]] }]));
    } else {
      message.error(ne.message as string);
    }
  };

  const [form] = Form.useForm<EditorValues>();
  const [updateState, update] = useApi(fcp.updateLawEnforcePoint, { onSuccess, onFailure });
  const [createState, create] = useApi(fcp.createLawEnforcePoint, { onSuccess, onFailure });

  const handleOk = () => form.submit();
  const handleSubmit = async (values: EditorValues) => {
    if (isEdit) {
      update({ lawEnforcePointId: lawEnforcePoint.id, body: values });
    } else {
      create({ body: values });
    }
  };

  const isLoading = updateState.loading || createState.loading;
  const title = isEdit ? '编辑执法点' : '新增执法点';
  const error = updateState.error || createState.error;

  return (
    <Modal title={title} open onOk={handleOk} onCancel={handleClose} confirmLoading={isLoading} width="650px">
      <Container>
        {error && <Alert message={error.message} type="error" />}
        <Form
          name="law-enforce-point-editor"
          labelCol={{ span: 6 }}
          wrapperCol={{ span: 18 }}
          initialValues={lawEnforcePoint}
          autoComplete="off"
          onFinish={handleSubmit}
          form={form}
        >
          <Form.Item label="执法点编号" name="code" rules={[{ required: true, message: '请填写执法点编号' }]}>
            <Input placeholder="填写执法点编号" />
          </Form.Item>
          <Form.Item label="执法点名" name="name" rules={[{ required: true, message: '请填写执法点名' }]}>
            <Input placeholder="填写执法点名" />
          </Form.Item>
        </Form>
      </Container>
    </Modal>
  );
};

const Container = styled.div`
  margin: 24px;
`;
